<div [class.blog-feed-compact]="compact" class="blog-feed">
    <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="mb-0">{{ compact ? '📝 Latest blogs & poems' : 'Blogs & Poems' }}</h4>
        <div>
            <a *ngIf="compact" class="rana-action-btn mr-2" routerLink="/blogs">See all</a>
            <a *ngIf="canWrite" class="btn btn-dark-primary" routerLink="/blogs/new">New Blog Post</a>
        </div>
    </div>

    <ng-template #card let-blog>
        <div class="card blog-card" [class.mb-3]="!compact">
            <a *ngIf="blog.coverImageUri && !compact" [routerLink]="['/blogs', blog.blogId]">
                <img [src]="blog.coverImageUri" class="card-img-top blog-cover" alt="">
            </a>
            <div class="card-body">
                <div class="d-flex align-items-center mb-2">
                    <img *ngIf="avatars[blog.authorId] as src" [src]="src" class="blog-avatar mr-2" alt="">
                    <span *ngIf="!avatars[blog.authorId]" class="blog-avatar blog-avatar-initials mr-2">{{ initials(blog.authorName) }}</span>
                    <div>
                        <a class="font-weight-500" [routerLink]="['/members', blog.authorId]">{{ blog.authorName }}</a><br>
                        <small class="text-muted">{{ blog.createdAtEpoch | date:'mediumDate' }} · {{ blog.category | titlecase }}</small>
                    </div>
                </div>
                <h5 class="card-title mb-1 blog-card-title">
                    <a [routerLink]="['/blogs', blog.blogId]">{{ blog.title }}</a>
                </h5>
                <p class="card-text mb-2 blog-card-excerpt">{{ blog.excerpt }}</p>
                <small class="text-muted">
                    <i class="uil uil-heart"></i> {{ blog.likeCount }}
                    <i class="uil uil-comment ml-3"></i> {{ blog.commentCount }}
                    <a class="ml-3" [routerLink]="['/blogs', blog.blogId]">Read more</a>
                </small>
            </div>
        </div>
    </ng-template>

    <!-- Compact (profile overview): auto-advancing carousel with prev/next arrows, like the committee slider -->
    <div *ngIf="compact" class="blog-carousel">
        <div #carousel class="blog-swiper">
            <div class="swiper-wrapper">
                <div class="swiper-slide" *ngFor="let blog of blogs">
                    <ng-container *ngTemplateOutlet="card; context: {$implicit: blog}"></ng-container>
                </div>
            </div>
        </div>
        <button type="button" class="blog-carousel-arrow blog-carousel-prev" aria-label="Previous" (click)="prev()">&#8249;</button>
        <button type="button" class="blog-carousel-arrow blog-carousel-next" aria-label="Next" (click)="next()">&#8250;</button>
    </div>

    <!-- Full page: stacked cards -->
    <div *ngIf="!compact">
        <ng-container *ngFor="let blog of blogs">
            <ng-container *ngTemplateOutlet="card; context: {$implicit: blog}"></ng-container>
        </ng-container>
        <button *ngIf="nextCursor && !loading" class="rana-action-btn" (click)="loadMore()">Load more</button>
    </div>

    <p *ngIf="loaded && blogs.length === 0" class="text-muted">No blogs yet. Be the first to write one.</p>
    <p *ngIf="loading" class="text-muted">Loading…</p>
</div>
